import { render, staticRenderFns } from "./CopyrightTwo.vue?vue&type=template&id=b67e5daa&scoped=true&"
import script from "./CopyrightTwo.vue?vue&type=script&lang=js&"
export * from "./CopyrightTwo.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightTwo.vue?vue&type=style&index=0&id=b67e5daa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67e5daa",
  null
  
)

export default component.exports